import React from 'react';

export function LandingBackground({ variant = 'light' }) {
  const isPanel = variant === 'panel';

  return (
    <div className="pointer-events-none absolute inset-0" aria-hidden="true">
      {/* Mesh gradients — kept in-bounds so parent overflow-hidden does not clip */}
      <div className="absolute inset-0 motion-reduce:animate-none animate-mesh-shift">
        <div
          className={`absolute rounded-full blur-3xl motion-reduce:animate-none animate-mesh-shift ${
            isPanel
              ? 'left-[2%] top-[0%] h-[min(420px,55%)] w-[min(420px,50%)] bg-blue-100/55 dark:bg-blue-600/25'
              : 'right-[0%] top-[2%] h-[min(380px,45%)] w-[min(380px,42%)] bg-blue-100/50 dark:bg-blue-950/25'
          }`}
        />
        <div
          className={`absolute rounded-full blur-3xl motion-reduce:animate-none animate-mesh-shift [animation-delay:6s] ${
            isPanel
              ? 'bottom-[0%] right-[2%] h-[min(360px,50%)] w-[min(360px,48%)] bg-slate-200/45 dark:bg-slate-600/20'
              : 'bottom-[0%] left-[0%] h-[min(320px,42%)] w-[min(320px,40%)] bg-slate-200/40 dark:bg-slate-800/30'
          }`}
        />
        <div
          className={`absolute rounded-full blur-3xl motion-reduce:animate-none animate-mesh-shift [animation-delay:12s] ${
            isPanel
              ? 'left-[35%] top-[45%] h-[min(280px,38%)] w-[min(280px,36%)] -translate-y-1/2 bg-indigo-100/35 dark:bg-blue-900/15'
              : 'left-1/3 top-1/2 h-[min(280px,38%)] w-[min(280px,36%)] -translate-y-1/2 bg-indigo-100/30 dark:bg-blue-900/15'
          }`}
        />
      </div>

      {/* Grain overlay */}
      <div className="landing-bg-noise absolute inset-0 opacity-[0.04] mix-blend-overlay dark:opacity-[0.06]" />

      {/* Perspective grid floor (hero panel) */}
      {isPanel && (
        <div className="landing-bg-grid-floor absolute inset-x-0 bottom-0 h-[55%] opacity-[0.06] dark:opacity-[0.18]" />
      )}

      {/* Dot matrix on panel */}
      {isPanel && (
        <div className="landing-bg-dot-matrix absolute inset-0 opacity-[0.04] dark:opacity-[0.06]" />
      )}

      {/* Scan line */}
      {isPanel && (
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue-500/20 to-transparent dark:via-blue-400/30 motion-reduce:opacity-0 animate-mesh-shift" />
      )}
    </div>
  );
}
